
import React from 'react';
import Layout from '@/components/Layout';

const UserProfilePage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Your Profile</h1>
        <p className="mt-4">View and edit your profile information.</p>
      </div>
    </Layout>
  );
};

export default UserProfilePage;
